/**
 * Theory Coffee Roasters — White-Label Landing Page
 * Vanilla JS · no jQuery · defer-loaded
 *
 * Presentation behaviors only. Analytics (cta_click via [data-ccr-cta]),
 * lead-form handling (attribution, validation, min-seconds), and experiments
 * are owned by the ccr-* engine scripts — nothing is tracked twice here.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- */
  /* Smooth scroll for anchor CTAs                                     */
  /* ---------------------------------------------------------------- */

  function initSmoothScroll() {
    document.querySelectorAll('[data-wl-scroll-to]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var targetId = trigger.getAttribute('data-wl-scroll-to');
        var target = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });

    document.querySelectorAll('a[href^="#whitelabel"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.getAttribute('href').slice(1);
        var target = document.getElementById(hash);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* FAQ accordion — aria-expanded sync                                */
  /* ---------------------------------------------------------------- */

  function initFaqAccordion() {
    document.querySelectorAll('.wl-faq__item').forEach(function (details) {
      var summary = details.querySelector('.wl-faq__summary');
      if (!summary) return;

      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Intersection Observer — fade-in sections                          */
  /* ---------------------------------------------------------------- */

  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.wl-animate').forEach(function (el) {
        el.classList.add('wl-animate--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wl-animate--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.wl-animate').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------- */
  /* Header elevation after scroll (presentation only)                 */
  /* ---------------------------------------------------------------- */

  function initHeaderScroll() {
    var header = document.querySelector('[data-wl-header]');
    if (!header) return;

    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle('wl-header--scrolled', window.scrollY > 8);
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  /* ---------------------------------------------------------------- */
  /* Sticky mobile CTA — slide away while the lead form is on screen   */
  /* (it points at the form; it must never cover the form's submit)    */
  /* ---------------------------------------------------------------- */

  function initStickyCtaVisibility() {
    var sticky = document.querySelector('.wl-sticky-cta');
    var form = document.getElementById('whitelabel-lead-form');
    if (!sticky || !form || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('wl-sticky-cta--hidden', entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { rootMargin: '0px 0px -15% 0px' }
    );

    observer.observe(form);
  }

  /* ---------------------------------------------------------------- */
  /* Chat prompt — opens AI chat, or scrolls to the lead form          */
  /* ---------------------------------------------------------------- */

  function scrollToLeadForm() {
    var target = document.getElementById('whitelabel-lead-form');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  function initChatTrigger() {
    var chatBtn = document.querySelector('[data-wl-open-chat]');
    if (!chatBtn) return;

    chatBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var CCR = window.CCR;

      if (CCR && CCR.chat && typeof CCR.chat.open === 'function') {
        CCR.chat.open(); // chat_open is tracked inside ccr-chat.js
      } else {
        // Chatbot script not loaded (toggle off / failed load) — form CTA.
        scrollToLeadForm();
        chatBtn.setAttribute('aria-describedby', 'wl-chat-fallback');
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* Volume MOQ note — honest coaching for under-50 / exploring        */
  /* ---------------------------------------------------------------- */

  function initVolumeMoqNote() {
    document.querySelectorAll('[data-wl-volume]').forEach(function (select) {
      var note = select.parentElement
        ? select.parentElement.querySelector('[data-wl-volume-note]')
        : null;
      if (!note) return;

      function sync() {
        var v = select.value;
        var show = v === 'under-50' || v === 'exploring';
        note.hidden = !show;
      }

      select.addEventListener('change', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Init                                                              */
  /* ---------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initSmoothScroll();
    initHeaderScroll();
    initFaqAccordion();
    initScrollAnimations();
    initStickyCtaVisibility();
    initChatTrigger();
    initVolumeMoqNote();
  }
})();
